import type { TrackingConfig } from './types';

/**
 * 默认配置
 */
export const DEFAULT_CONFIG: TrackingConfig = {
  enabled: true,
  endpoint: '',
  autoPageView: true,
  autoClickTracking: true,
  recordDeviceInfo: true,
  debug: process.env.NODE_ENV === 'test',
  sourceMapEnable: false,
};

/**
 * 监听指定页面
 */
export const MONITOR_PAGE = ['/search', '/user-center/search-history/', '/user-center/security/'];
